import { useMyOrderIntentionsContext } from 'contexts/MyOrderIntentionsContext';
import moment from 'moment';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as MyOrderIntentionEditCalls from 'store/state/myOrderIntentionEdit/apiCalls';
import { myOrderIntentionEditSelectors } from 'store/state/selectors';
import { alertActions } from 'store/state/slices';

export function useOrderIntentionsExport() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { formFilter, activeFilters } = useMyOrderIntentionsContext();
  const filterExport = useSelector(
    myOrderIntentionEditSelectors.getFilterExport,
  );
  const [isExporting, setIsExporting] = useState(false);

  const exportReport = useCallback(async () => {
    const filters = formFilter.getFieldsValue();
    const completeFilters = {
      ...filters,
      date: filters.date && [
        moment(filters.date[0]).format('DD/MM/YYYY'),
        moment(filters.date[1]).format('DD/MM/YYYY'),
      ],
    };
    const completeActive = {
      ...activeFilters,
      date: activeFilters.date && [
        moment(activeFilters.date[0]).format('DD/MM/YYYY'),
        moment(activeFilters.date[1]).format('DD/MM/YYYY'),
      ],
    };

    if (JSON.stringify(completeFilters) === JSON.stringify(completeActive)) {
      setIsExporting(true);
      try {
        await dispatch(MyOrderIntentionEditCalls.exportPurchases(filterExport));
      } finally {
        setIsExporting(false);
      }
    } else {
      dispatch(
        alertActions.alertRequest({
          message: t('myOrderIntentions.searchAgain'),
          type: 'warning',
          showIcon: true,
          timeout: 3000,
        }),
      );
    }
  }, [activeFilters, dispatch, filterExport, formFilter, t]);

  return { exportReport, isExporting, canExport: Boolean(filterExport) };
}
